import React from 'react';

import * as styles from './DeliveryEventMessage.styles';

interface DeliveryEventMessageProps {
  eventName: string;
}

export const DeliveryEventMessage = ({ eventName }: DeliveryEventMessageProps) => {
  return (
    <strong css={styles.root}>
      ESTIMATED DELIVERY BY <em>{eventName.toUpperCase()}</em>
    </strong>
  );
};
